import { useMutation } from 'react-query'

import { fetchContactAccountStatement, type FetchContactAccountStatementParams } from '../query-api'

interface UseExportContactAccountStatementProps {
  onError?: (error: unknown) => void
  onSuccess?: (statement: Blob, params: FetchContactAccountStatementParams) => void
}

export const useExportContactAccountStatement = (props?: UseExportContactAccountStatementProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: exportStatement,
    isLoading: isExporting,
    ...rest
  } = useMutation(
    async (params: FetchContactAccountStatementParams) => {
      const response = await fetchContactAccountStatement(params)

      return response.blob()
    },
    { onError, onSuccess },
  )

  return { exportStatement, isExporting, ...rest }
}
